module.exports = __webpack_public_path__ + "fonts/fa-brands-400.f075c50f.woff2";